import styled from "styled-components";

export const TextFacebook = styled.span`
  color: #707070;
  margin: 0 0 0 .5rem;

  p {
    margin-bottom: 0rem;
  }
`;